// NOTE ON THIS FILE
// ------------------
// getCaptcha/submitWhitelist call Postgres RPC functions (public.get_captcha,
// public.submit_whitelist) instead of a server function or Edge Function.
// Those functions are SECURITY DEFINER and do all validation, captcha
// signing/verification, and the actual insert server-side (see
// supabase/migrations/20260725064500_rpc_secure_whitelist.sql) -- this file
// is just a thin, typed wrapper around supabase.rpc(...). See
// CONVERSION_NOTES.md for the full security explanation.

import { supabase } from "../integrations/supabase/client";

export type Captcha = { question: string; token: string };

export async function getCaptcha(): Promise<Captcha> {
  const { data, error } = await supabase.rpc("get_captcha");
  if (error) {
    throw new Error(error.message || "Could not load captcha");
  }
  // get_captcha() is a table-returning function -- PostgREST/supabase-js
  // returns those as an array of rows; there's always exactly one row here.
  const row = Array.isArray(data) ? data[0] : data;
  if (!row) {
    throw new Error("Could not load captcha");
  }
  return row as Captcha;
}

export type WhitelistSubmissionInput = {
  followed: boolean;
  liked: boolean;
  retweeted: boolean;
  reply_link: string;
  wallet_address: string;
  captcha_token: string;
  captcha_answer: string;
};

export async function submitWhitelist(
  data: WhitelistSubmissionInput,
): Promise<{ ok: true }> {
  const { data: result, error } = await supabase.rpc("submit_whitelist", {
    p_followed: data.followed,
    p_liked: data.liked,
    p_retweeted: data.retweeted,
    p_reply_link: data.reply_link,
    p_wallet_address: data.wallet_address,
    p_captcha_token: data.captcha_token,
    p_captcha_answer: data.captcha_answer,
  });
  if (error) {
    // Postgres RAISE EXCEPTION messages/errcodes come through as
    // error.message / error.code (e.g. '23505' for the duplicate-wallet case).
    throw new Error(error.message || "Submission failed");
  }
  return result as { ok: true };
}
